import axios from '../axios/axios';

export function getThreadsApi() {
  return axios.post('/threads/get', {});
}

export function getPostsApi(params) {
  return axios.post('/content/posts', params);
}

export function getCommentsApi(params) {
  return axios.post('/content/commentaries', params);
}

export function getReCommentsApi(params) {
  return axios.post('/content/childcommentaries', params);
}

export function getStatisticApi(params) {
  return axios.post('/content/gettodaytrust', params);
}

export function getStatisticOverAllApi(params) {
  return axios.post('/content/getweektrust', params);
}
